import { type VariantProps, cva } from 'class-variance-authority'
import { ReactNode } from 'react'
import { DrilldownButton } from '~/components/button'

import { AnalyticsQueryFilter } from '@hap/analytics'
import { Skeleton, cn } from '@hap/components'

const metricVariants = cva('font-bold  flex items-stretch gap-3', {
  variants: {
    variant: {
      default: 'text-3xl',
      md: 'text-xl',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})

export type MetricVariants = VariantProps<typeof metricVariants>

interface Props extends MetricVariants {
  label: string
  value: ReactNode
  trend?: ReactNode
  loading?: boolean
  drilldown?: boolean
  drilldownFilters?: AnalyticsQueryFilter[]
  className?: string
}

export function MetricCellBase(props: Props) {
  const loading = props.loading || false
  return (
    <div className={cn('bg-accent flex gap-4 rounded-md p-4', props.className)}>
      <div className="grow">
        <div className={metricVariants({ variant: props.variant })}>
          <Skeleton className="min-w-[70px]" loading={loading}>
            {props.value || '—'}
          </Skeleton>
          {!!props.trend && (
            <Skeleton className="min-w-[40px]" loading={loading} asChild>
              {props.trend}
            </Skeleton>
          )}
        </div>
        <div className="opacity-40">{props.label}</div>
      </div>
      {!!props.drilldown && <DrilldownButton filters={props.drilldownFilters} />}
    </div>
  )
}
